import { ChangeDetectionStrategy, Component, computed, effect, ElementRef, input, viewChild } from '@angular/core';
import { markdownToHtml } from '../../../../common/markdown-to-html';

/** Live-scrolling panel showing streamed AI reasoning prose during brief drafting. */
@Component({
  selector: 'bb-ai-thoughts-scroll',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './bb-ai-thoughts-scroll.html',
})
export class BbAiThoughtsScroll {
  readonly thoughts = input<string>('');
  readonly statusLabel = input<string>('Thinking it through…');
  readonly isCompiling = input(false);
  readonly compilingLabel = input<string>('Finalising your brief…');
  readonly showStatus = input(true);

  readonly renderedThoughts = computed(() => markdownToHtml(this.thoughts()));

  private readonly thoughtsScroll = viewChild<ElementRef<HTMLElement>>('thoughtsScroll');

  constructor() {
    effect(() => {
      this.thoughts();
      this.isCompiling();
      const element = this.thoughtsScroll()?.nativeElement;
      if (element) {
        element.scrollTop = element.scrollHeight;
      }
    });
  }
}
